<template>
  <div>
    <div
      v-if="grahas && box_width && is_home_View == true"
      class="planetry-table mt-4 mt-lg-0"
      :style="`padding: 5px; margin: 5px; min-width: 320px; font-size: 14px; box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);      border-radius: 8px;
      border: 1px solid #ccc;
      background-color: #f2f2f2;`"
    >
      <table class="table">
        <tr>
          <td class="px-0" style="text-align: center" colspan="2">Planet</td>
          <td class="px-0" style="text-align: center">Sign</td>

          <td class="px-0" style="text-align: center">Degree</td>
        </tr>

        <tr style="text-align: center" v-for="item in planet_order" :key="item">
          <td class="px-0 py-1" style="text-align: center">
            <img
              :src="'https://www.horastro.co/wp-content/uploads/2022/08/' + item + '.png'"
              width="30"
            />
          </td>
          <td
            class="px-0 py-1"
            style="background: white; border: 1px solid #ccc; text-align: center"
          >
            <strong>{{ formatPlanetName(item) }}</strong>
          </td>
          <td
            class="px-0 py-1"
            style="background: white; border: 1px solid #ccc; text-align: center"
          >
            {{ grahas[item]["rashi_name"] }}
            ({{ grahas[item]["rashi"] }})
          </td>

          <td
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              font-weight: bold;
            "
          >
            {{ formatDegree(grahas[item]) }}
          </td>
        </tr>
      </table>
    </div>
    <div
      v-if="grahas && box_width && is_home_View == false"
      class="planetry-table"
      :style="`padding: 5px; font-size: ${font_size}px;`"
    >

      <table class="table">
        <tr style="font-weight: bold">
          <td
            class="px-0 py-1"
            colspan="2"
            style="
              background-color: #fff;
              border-bottom: 1px solid #ccc;
              border-left: 1px solid #ccc;
              border-top: 1px solid #ccc;
              text-align: center;
            "
          >
            Planet
          </td>
          <td
            class="px-0 py-1"
            style="
              background-color: #fff;
              border-bottom: 1px solid #ccc;
              border-top: 1px solid #ccc;
              text-align: center;
            "
          >
            Sign
          </td>
          <td
            v-if="show_nakshatra"
            class="px-0"
            style="
              background-color: #fff;
              border-bottom: 1px solid #ccc;
              border-left: 1px solid #ccc;
              border-top: 1px solid #ccc;
              text-align: center;
            "
          >
            Nakshatra
          </td>
          <td
            class="px-0 py-1"
            style="
              background-color: #fff;
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              border-top: 1px solid #ccc;
              text-align: center;
            "
          >
            Degree
          </td>
        </tr>

        <tr style="text-align: center">
          <td class="px-0 py-1" style="text-align: center">
            <img
              :src="
                'https://www.horastro.co/wp-content/uploads/2022/08/' +
                lagna['Lg']['rashi_name'] +
                '.png'
              "
              width="30"
            />
          </td>
          <td
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              border-bottom: 1px solid #000;
            "
          >
            <strong>As</strong>
          </td>
          <td
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              font-weight: bold;
              border-bottom: 1px solid #000;
            "
          >
            {{ lagna["Lg"]["rashi_name"] }}
            ({{ lagna["Lg"]["rashi"] }})
          </td>

          <td
            v-if="show_nakshatra"
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              font-weight: bold;
              border-bottom: 1px solid #000;
            "
          >
            {{ lagna["Lg"]["nakshatra"]["name"] }}
            ({{ lagna["Lg"]["nakshatra"]["pada"] }}/4)
          </td>
          <td
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              font-weight: bold;
              font-weight: bold;
              border-bottom: 1px solid #000;
            "
          >
            {{ formatDegree(lagna["Lg"]) }}
          </td>
        </tr>

        <tr style="text-align: center" v-for="item in planet_order" :key="item">
          <td class="px-0 py-1" style="text-align: center">
            <img
              :src="'https://www.horastro.co/wp-content/uploads/2022/08/' + item + '.png'"
              width="30"
            />
          </td>
          <td
            class="px-0 py-1"
            style="background: white; border: 1px solid #ccc; text-align: center"
          >
            <strong>{{ formatPlanetName(item) }}</strong>
          </td>
          <td
            class="px-0 py-1"
            style="background: white; border: 1px solid #ccc; text-align: center"
          >
            {{ grahas[item]["rashi_name"] }}
            ({{ grahas[item]["rashi"] }})
          </td>

          <td
            v-if="show_nakshatra"
            class="px-0 py-1"
            style="background: white; border: 1px solid #ccc; text-align: center"
          >
            {{ grahas[item]["nakshatra"]["name"] }}
            ({{ grahas[item]["nakshatra"]["pada"] }}/4)
          </td>
          <td
            class="px-0 py-1"
            style="
              background: white;
              border: 1px solid #ccc;
              text-align: center;
              font-weight: bold;
            "
          >
            {{ formatDegree(grahas[item]) }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import HelperLib from "./helper";

export default {
  name: "PlanetryTableFree",
  components: {
    HelperLib,
  },
  // props: ['grahas', 'lagna', 'box_width', 'is_home_view'],
  props: {
    grahas: {
      type: Object,
    },
    lagna: {
      type: Object,
    },
    box_width: {
      type: Number,
    },
    is_home_View: {
      type: Boolean,
      default: false,
    },
    show_nakshatra: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planet_order: ["Su", "Mo", "Ma", "Me", "Ju", "Ve", "Sa", "Ra", "Ke"],
      font_size: "14",
    };
  },
  mounted() {
    if (HelperLib.isMobile()) {
      this.font_size = "12";
    }
    this.createPlanetryTable();
  },
  methods: {
    createPlanetryTable() {},
    formatDegree(graha) {
      return HelperLib.formatDegText(
        graha["degree_dms"]["deg"],
        graha["degree_dms"]["min"],
        parseInt(graha["degree_dms"]["sec"])
      );
    },
    formatPlanetName(graha) {
      let name = graha;
      if (this.grahas[graha]["speed"] < 0 && graha !== "Ra" && graha !== "Ke") {
        name = name + "R";
      }
      return name;
    },
  },
};
</script>
<style scoped>
.planetry-table {
}
</style>
